/**
 * Validates password against weak password policy
 * Requirements:
 * - Minimum 8 characters
 * - At least one special character
 * - At least one capital letter
 */
export const validateWeakPassword = (password) => {
  const errors = [];

  if (!password) {
    return {
      isValid: false,
      errors: ["Password is required"],
    };
  }

  // Check minimum length
  if (password.length < 8) {
    errors.push("Password must be at least 8 characters");
  }

  // Check for at least one capital letter
  if (!/[A-Z]/.test(password)) {
    errors.push("Password must contain at least one capital letter");
  }

  // Check for at least one special character
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    errors.push("Password must contain at least one special character");
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

/**
 * Returns a formatted string of all password policy errors
 */
export const getPasswordErrorMessage = (password) => {
  const validation = validateWeakPassword(password);
  return validation.errors.join("\n");
};